import React, { useEffect } from 'react';
import { Trans } from 'next-i18next';
import { useSearchParams } from 'next/navigation';
import LinkText from 'src/components/LinkText/LinkText';
import { setBookingLink, useUnauthorizedContext, useUnauthorizedDispatch } from 'src/components/providers/UnauthorizedProvider';
const LoginSubheading = () => {
  const dispatch = useUnauthorizedDispatch();
  const {
    bookingLink
  } = useUnauthorizedContext();
  const search = useSearchParams();
  const searchBookingLink = search.get('bookingLink');
  useEffect(() => {
    if (searchBookingLink) {
      dispatch(setBookingLink(searchBookingLink));
    }
  }, [searchBookingLink]);
  return bookingLink ? /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "b2c.login.external.subheading",
    components: [/*#__PURE__*/React.createElement(LinkText, {
      key: "booking-link",
      href: bookingLink
    })]
  }) : /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "b2c.login.subheading",
    components: [/*#__PURE__*/React.createElement(LinkText, {
      key: "registration-link",
      href: "/registration"
    })]
  });
};
export default LoginSubheading;